<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="12" md="12"><span style="display: inline;">
                        <p style="display: inline-block; margin:0px;">JDW Credit In:&nbsp; </p>
                        <p class="float-right" style=" display:inline-block; padding:0px; margin:0px;"
                            :class="($vuetify.theme.dark) ? 'darkPrime' : 'lightPrime'"> £{{
                                    myNumberWithTwoDecimalPlaces =
                                    parseFloat(incoming).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}</p>
                        <v-progress-linear :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                            :value="incomingbar"></v-progress-linear>
                    </span><br>
                    <span style="display: inline;">
                        <p style="display: inline-block; margin:0px;">JDW Credit Withdrawn:&nbsp; </p>
                        <p class="float-right" style=" display:inline-block; padding:0px;margin:0px;"
                            :class="($vuetify.theme.dark) ? 'darkPrime' : 'lightPrime'"> £{{
                                    myNumberWithTwoDecimalPlaces =
                                    parseFloat(outgoing).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}</p>
                        <v-progress-linear :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                            :value="outgoingbar"></v-progress-linear>
                    </span>
                </v-col>
            </v-row>

            <v-row>

                <v-col>
                    <v-divider></v-divider>
                    <div style="padding-top:12px;">
                        <div class="float-left">
                            <b class="float-left" style="margin:0px; margin-top:15px;">All Transactions <i>(By
                                    month)</i></b>
                        </div>
                        <div class="float-right" style=" margin-top:7px;">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, atts }">
                                    <v-btn :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                                        v-bind="atts" v-on="on">
                                        Year: {{ yearSelection }}
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-for="index in years" :key="index">
                                        <v-list-item-title v-on:click="yearSelection = index">{{ index }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>


                </v-col>
                <v-col cols="12" md="12" style="padding:0px;">
                    <!-- Carefull reorderin these 12-tabindex will be close to selection. -->
                    <v-tabs v-model="tabSelection"
                        :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" show-arrows>
                        <v-tab v-for="(month, i) in chosenMonths" :key="i">{{ month }}</v-tab>
                    </v-tabs>
                </v-col>

                <v-col ols="12" md="12" v-if="isLoadingTransactions" align="center">
                    <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                        size="72" indeterminate></v-progress-circular>
                </v-col>
                <v-col cols="12" md="12">
                    <transaction-line v-if="!isLoadingTransactions" v-bind:monthSelection="tabSelection"
                        v-bind:yearSelection="yearSelection" filterDate="true" takenHeight="310"
                        :allTransactions="transactions" :sizeOfMonths="chosenMonths.length"></transaction-line>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>

import TransactionLine from "../components/TransactionLine.vue";
import RestResource from '../RestResource.js';
import accessHelper from "@/mixins/accessHelper";
import { mapGetters } from 'vuex';
const restResourceService = new RestResource();

export default ({
    name: "AllTransactionsPage",
    components: {
        TransactionLine,
    },
    props: {

    },
    mixins: [accessHelper],
    data: () => ({
        isLoadingTransactions: false,
        tabSelection: 0,
        months: ["December", "November", "October", "September", "August", "July", "June", "May", "April", "March", "February", "January"],
        chosenMonths: [],
        yearSelection: "",
        years: [],
        dateSelection: ["", ""],
        transactions: [],
        incoming: 0,
        outgoing: 0,
        incomingbar: 0,
        outgoingbar: 0,
        fees: 0,
    }),
    computed:
        mapGetters([
            'getAccount',
            'getAccountBalance',
            'getIsLoadingAccountBalance',
            'getIsLoadingAccount',
        ]),
    mounted: function () {
        this.getYearsList();
    },
    //Can't watch store.getAccount because this relys on selected date to mount
    watch: {
        tabSelection: function () {
            this.getTransactions();
        },
        yearSelection: function () {
            this.setTabSelection();

        },
    },
    methods: {
        async getTransactions() {
            //Month selected by tab
            this.isLoadingTransactions = true;
            let selection = this.chosenMonths.length - this.tabSelection;
            let monthSelected;
            if (selection < 10) {
                monthSelected = new Date(this.yearSelection + "-0" + selection);
            } else {
                monthSelected = new Date(this.yearSelection + "-" + selection);
            }
            //get start end of the month 
            let startDate = new Date(monthSelected.getFullYear(), monthSelected.getMonth(), 1);
            let endDate = new Date(monthSelected.getFullYear(), monthSelected.getMonth() + 1, 0);
            const transactions = await restResourceService.getTransactions(startDate, endDate);
            this.transactions = transactions;
            this.isLoadingTransactions = false;
            this.calcBarValues();
        },
        //Calculates the in and out bar positions at the top of page
        calcBarValues: function () {
            this.incoming = 0;
            this.outgoing = 0;
            this.incomingbar = 0;
            this.outgoingbar = 0;
            this.totaloutandin = 0;
            this.fees = 0;

            this.transactions.forEach(element => {

                if (element.type == 'CHIP' || element.type == 'CHIP2')
                    this.incoming = this.incoming + Math.abs(element.amount);
                else if (element.type == 'PAY-OUT')
                    this.outgoing = this.outgoing + (element.amount);
                else
                    this.fees = this.fees + (element.amount);
            });
            this.totaloutandin = this.incoming + this.outgoing;
            if (this.totaloutandin > 0) {
                this.incomingbar = (((this.incoming - this.fees)-this.outgoing) / this.outgoing) * 100;
                this.outgoingbar = (this.outgoing / (this.incoming - this.fees)) * 100;
            }
        },
        //Get years between now and 2022
        getYearsList: function () {
            let today = new Date();
            let currentYear = today.getFullYear();
            this.yearSelection = currentYear.toString();
            //This will always add 2022
            for (var y = 2022; y <= currentYear; y++)
                this.years.push(y.toString());
        },
        setTabSelection: function () {
            let today = new Date();
            let currentMonthIndex = 12 - (today.getMonth() + 1);
            let currentYear = today.getFullYear();
            if (currentYear == this.yearSelection) {
                //Need to clone so the list is intact for later
                let cloneMonths = this.months.slice();
                this.chosenMonths = cloneMonths.splice(currentMonthIndex);
            } else {
                this.chosenMonths = this.months;
            }
            this.tabSelection = 0;
            this.getTransactions();
        }
    },
})
</script>
<style scoped>
</style>